import config from '../config/config.json';

interface JsonConfig {
    SENTRY_DSN: string,
    BASE_URL: string,
    API_URL: string,
    GOOGLE_MAPS_API_KEY: string
    CONTROL_URL: string,
    CREATE_SHOW_URL: string,
    MY_SHOWS_URL: string,
    GOOGLE_MAPS_KEY: string,
    MAINTENANCE_MODE: boolean,
    GTAG_ID: string,
    CONTACT_FORM_URL: string,
    WHATSAPP_URL: string,
    MICROSOFT_CLARITY_ID: string
}

const useJsonConfig = (): JsonConfig => {
    return config as JsonConfig;
}

export { useJsonConfig }
